/**
 * Where a floating panel may sit (MYD-644): shared by the Chat popup and the
 * floating panel, so a dragged panel is kept on screen the same way in both.
 *
 * Pure, with the viewport passed in, so the geometry is testable without a
 * layout engine.
 */

export interface Point {
	x: number
	y: number
}

/** Minimum gap between a panel and the viewport edge, dragged or not. */
export const EDGE_MARGIN = 8

/**
 * Keeps the panel fully on screen. Covers both a drag toward an edge and a
 * viewport resize that would otherwise strand a dragged panel out of reach,
 * taking its close button with it.
 */
export const clampToViewport = (
	{ x, y }: Point,
	width: number,
	height: number,
	viewportW = window.innerWidth,
	viewportH = window.innerHeight,
): Point => ({
	x: Math.min(Math.max(x, EDGE_MARGIN), Math.max(EDGE_MARGIN, viewportW - width - EDGE_MARGIN)),
	y: Math.min(Math.max(y, EDGE_MARGIN), Math.max(EDGE_MARGIN, viewportH - height - EDGE_MARGIN)),
})

/** Dead centre of the viewport for a panel of this size, kept on screen. */
export const centredIn = (width: number, height: number, viewportW = window.innerWidth, viewportH = window.innerHeight): Point => ({
	x: Math.max(EDGE_MARGIN, (viewportW - width) / 2),
	y: Math.max(EDGE_MARGIN, (viewportH - height) / 2),
})
